export const MINICART_UPDATE = (state, data) => {
  if (data && data.minicart && state.data) {
    state.data.minicart = data.minicart;
  }
};
